import React from "react";
import { PageLayout } from "../../components";
import { useAnswersReview } from "./useAnswersReview";
import "./style.scss";
import { sortAnswers } from "../helpers";
import { renderCorrectLabel } from "../ConditionAnswersReview/helpers";

const AnswersReview = () => {
  const {
    hasChanged,
    questions,
    questionsAndAnswers,
    handleChange,
    navigate,
    analyticSearchParam
  } = useAnswersReview();

  return (
    <PageLayout>
      <PageLayout.Header title="Your answers" step={13} />
      <PageLayout.Content backgroundColour={null}>
        <div>
          <h1 className="ch-fs--4 ch-mb--1">Your answers</h1>
          <p className="ch-fs--3 ch-mb--4">
            Making updates to your answers will change your valuation.
          </p>
          {questions.length > 0 &&
            questions?.map((question) => {
              let sortedAnswers = sortAnswers(question.answers)
              return (
                <div className="ch-form__group">
                  <p className="ch-width--12 ch-form__control-label">
                    {question.content}
                  </p>
                  { (
                    <select
                      className="ch-form__control"
                      onChange={({ target: { value } }) => {
                        handleChange({
                          questionId: question.id,
                          answerId: Number(value)
                        });
                      }}
                    >
                      {sortedAnswers.map((answer: any) => {
                        return (
                          <option
                            selected={
                              questionsAndAnswers[question.id][0] === answer.id
                            }
                            value={answer.id}                          >
                            {renderCorrectLabel(question, answer)}
                          </option>
                        );
                      })}
                    </select>
                  )}
                </div>
              );
            })}
        </div>
        {hasChanged && (
          <div
            style={{ border: "solid 1px orange" }}
            className="ch-alert ch-alert--warning orange-br-alert ch-mt--4 md:ch-mt--8 ch-fs--3"
          >
            Making these changes will update and change your valuation
          </div>
        )}
        <button
          className={`your-answers-CTA ch-btn ch-btn--success ch-display--block ch-mh--auto ch-width--12 ${hasChanged ? "ch-mt--5 md:ch-mt--4" : "ch-mt--8"
            }`}
          type="button"
          onClick={() => {
            navigate("/estimated-offer");
        }}
        >
          {hasChanged ? "Change and update answers" : "OK"}
        </button>
      </PageLayout.Content>
    </PageLayout>
  );
};

export default AnswersReview;
